<template>
    <div
        class="rich-text-editor"
        :style="{
            ...defaultStyle,
            ...titleStyle,
            paddingLeft: slotIcon ? '30px' : '',
        }"
    >
        <div ref="editorContent" contenteditable="true" class="editor-content" @focus="inputFocus" @blur="inputBlur" v-html="content"></div>
        <rich-text-type
            class="type"
            contenteditable="false"
            ref="richTextType"
            v-show="typeShow"
            @operationDialog="operationDialog"
            :edit-element="editorContent"
        />
        <!-- v-show="typeShow"  -->
        <slot name="icon" />
        <slot name="operation" />
        <!-- 富文本编辑器弹框 -->
        <el-dialog v-model="editorDialogVisible" title="富文本编辑器" width="60%" center>
            <div style="border: 1px solid #ccc">
                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
                <Editor
                    style="height: 400px; overflow-y: hidden"
                    v-model="valueHtml"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="handleCreated"
                />
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="operationButton(false)">取消</el-button>
                    <el-button type="primary" @click="operationButton(true)"> 确定 </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, useSlots, shallowRef, watch } from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
// import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import RichTextType from "./RichTextType.vue";
import { editorConfig } from "../../utils/editorConfig.js";
import { keepCursorEnd } from "../../utils/index";
const props = defineProps({
    valueData: {
        type: String || Number,
        default: "",
    },
    defaultStyle: {
        type: Object,
        default: () => {},
        required: false,
    },
});
const emits = defineEmits(["update:valueData", "focus", "blur"]);
const slotIcon = useSlots().icon;
const content = ref(""); // 编辑器内默认展示值
content.value = props.valueData;
const editorRef = shallowRef(); // 富文本编辑器实例
const valueHtml = ref(""); // 富文本编辑器内容
const toolbarConfig = {};
const mode = "default";
let titleStyle = ref({}); // 鼠标移入和点击时得样式
let typeShow = ref(false); //是否展示操作栏
let editorContent = ref(null); // 编辑器内容区域元素标签
let richTextType = ref(null); // 操作栏得元素
let editorDialogVisible = ref(false); //富文本编辑器显示隐藏
watch(
    () => props.valueData,
    (newValue) => {
        content.value = newValue;
    }
);
defineExpose({ editorContent, editorDialogVisible, typeShow });
onMounted(() => {
    responsive();
});
onBeforeUnmount(() => {
    // 销毁组件时销毁编辑器
    const editor = editorRef.value;
    if (editor == null) return;
    editor.destroy();
});
// 实现响应式
function responsive() {
    // 动态赋值
    content.value = editorContent.value.innerHTML;
    // emits('change',content);
    emits("update:valueData", content);
}
// 输入框聚焦，修改外部样式
function inputFocus(e) {
    editorContent.value = e.target;
    titleStyle.value = {
        background: "rgba(238, 240, 245, 1)",
        border: "1px solid rgba(155, 173, 252, 1)",
    };
    // 显示顶部操作栏
    typeShow.value = true;
    emits("focus", editorContent.value);
}

// 输入框失去焦点 样式还原
function inputBlur(e) {
    titleStyle.value = {};
    typeShow.value = false;
    emits("blur");
    // 动态赋值
    responsive();
}
// 弹框取消和确认
function operationButton(status) {
    editorDialogVisible.value = false;
    if (status) {
        content.value = valueHtml.value;
    }
    // 指针固定在最后
    setTimeout(() => {
        keepCursorEnd(editorContent.value);
    }, 5);
}
function operationDialog(status) {
    editorDialogVisible.value = status;
    valueHtml.value = content.value;
}
// 富文本编辑器实例化
function handleCreated(editor) {
    editorRef.value = editor; // 记录 editor 实例，重要！
}
</script>
<style lang="scss" scoped>
@use "@wangeditor/editor/dist/css/style.css" as *;
.rich-text-editor {
    min-height: 37px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px dashed rgba(0, 0, 0, 0);
    box-sizing: border-box;
    position: relative;
    // border-radius: 4px;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    .type {
        position: absolute;
        top: -47px;
        left: 0;
        z-index: 8888;
    }
    .editor-content {
        width: 100%;
        height: auto;
        padding: 3px 6px;
        border: none !important;
        background-color: rgba(0, 0, 0, 0);
    }
    .editor-content:focus {
        outline: none;
        box-shadow: none;
    }

    &:hover {
        border: 1px solid rgba(155, 173, 252, 1);
    }
    // 清除默认样式
    .ant-input {
        padding-left: 0;
        height: 80%;
        color: rgb(72, 72, 72);
        font-size: 16px;
        border: none !important;
        background-color: rgba(0, 0, 0, 0);
    }
    .ant-input:focus,
    .ant-input-focused {
        border: none;
        box-shadow: none;
    }
}
</style>
